import { render, staticRenderFns } from "./HistoryOftaComponent.vue?vue&type=template&id=0bbff8c2&scoped=true&"
import script from "./HistoryOftaComponent.vue?vue&type=script&lang=js&"
export * from "./HistoryOftaComponent.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOftaComponent.vue?vue&type=style&index=0&id=0bbff8c2&lang=scss&scoped=true&"
import style1 from "./HistoryOftaComponent.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./HistoryOftaComponent.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbff8c2",
  null
  
)

export default component.exports